import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownInsuranceContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownInsuranceContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownInsuranceContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownInsuranceContracts/${id}`, request)
}

export {get, post, put, patch}
